// extracted by mini-css-extract-plugin
export default {"referenceCell":"ut1cJJxsbrE81w5gNcyt"};